import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { alertPageError } from 'src/app/constants/error-message-constant';

@Component({
  selector: 'app-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.scss']
})
export class AlertDialogComponent implements OnInit {
  title: any;
  message: any;
  errorMessage:any=[];
  constructor(public dialogRef: MatDialogRef<AlertDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    if (data) {
      this.title = data.title;
      this.message = data.message;
    }
  }

  ngOnInit(): void {
    this.errorMessage=alertPageError;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
